export type { MediaTestimonialProps } from './MediaTestimonial'
export { default as MediaTestimonialBlock } from './MediaTestimonial'
